<div class="spinner-loader-overlay" [class.spinner-loader-inline]="inline">
  <div class="spinner-loader-container">
    <div class="spinner" [attr.data-size]="size" [style.--spinner-delay]="delay + 'ms'"></div>
  </div>
</div>
